import styled from 'styled-components';
import { Layout } from 'antd';
import { theme } from 'consts/theme';

export const StyledLayout = styled(Layout)`
  margin: 0;
  // Set the height of the layout to the viewport height dynamically
  height: calc(var(--vh, 1vh) * 100);
  width: 100vw;
  background-color: ${theme.colors.lightGray};
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
`;
